import { useEffect, useState } from "react";
import warehouseAPI from "../../../../api/inventory/warehouseApi";

export default function LocationSelect({
  name,
  value,
  onChange,
  showAll = false,
  className = "form-select",
  required = false,
}) {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLocations = async () => {
    setLoading(true);

    try {
      const res = await warehouseAPI.getLocations();
      if (res.code === 200) {
        setLocations(res.data || []);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  return (
    <select
      name={name}
      className={className}
      value={value || ""}
      onChange={onChange}
      disabled={loading}
      required={required}
    >
      <option value="">— Select location —</option>
      {showAll && <option value="all">All Locations</option>}
      {locations.map((l) => (
        <option key={l._id} value={l._id}>
          {l.wareHouseName}
          {l.wareHouseId ? ` (${l.wareHouseId})` : ""}
        </option>
      ))}
    </select>
  );
}
